import { CardComponent } from '../../../shared/components/card/card.component';
import { ChangeDetectorRef, Component, inject, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Button } from '../../../shared/components/button/button.component';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { Table } from '../../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { MATERIAS_ACTIONS, MATERIAS_COLUMN_NAMES, MATERIAS_FIELDS_CONFIG, MATERIAS_PAGINATION_OPTIONS_DEFAULT } from '../../../constants/materias.constants';
import { BaseList } from '../../../shared/baseList.component';
import { MateriasService } from '../../../core/materias.service';
import { MateriaInterface } from '../../../models/materia.model';
import { Select } from '../../../shared/components/select/select.component';
import { ModalidadService } from '../../../core/modalidad.service';
import { NivelService } from '../../../core/nivel.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TITULOS_MOTIVOS_BAJA } from '../../../constants/titulos.constants';
import { TituloService } from '../../../core/titulo.service';
import { CompetenciasService } from '../../../core/competencia.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MateriasPlanService } from '../../../core/materiasPlan.service';
import { DEFAULT_PAGINATE_OPTIONS_LIST, defaultPaginateSelects, PaginateOptions } from '../../../utils/paginate.utils';
import { PaginationService } from '../../../shared/services/pagination.service';
import { AutocompleteFieldComponent } from '../../../shared/components/autocomplete-field/autocomplete-field.component';

@Component({
  selector: 'app-materias',
  imports: [
    CardComponent,
    Table,
    Button,
    RouterModule,
    Titledescription,
    Select,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    CommonModule,
    FormsModule,
    MatProgressSpinnerModule,
    AutocompleteFieldComponent
  ],
  templateUrl: './materias-list.html',
  styleUrl: './materias-list.scss'
})
export class Materias extends BaseList<MateriaInterface> {
  entityKey = 'materias';
  trackByTitulo(index: number, item: any): any {
    return item && item.value ? item.value : index;
  }
  apiService = inject(MateriasPlanService);
  materiasService = inject(MateriasService);
  modalidadService = inject(ModalidadService);
  nivelService = inject(NivelService);
  tituloService = inject(TituloService);
  columnNames = MATERIAS_COLUMN_NAMES;
  fields = MATERIAS_FIELDS_CONFIG;
  nivelSelected: number = 0;
  modalidadSelected: number = 0;
  dataSelectNiveles: any[] = [];
  dataSelectModalidades: any[] = [];
  actions = MATERIAS_ACTIONS;
  motivosBaja = TITULOS_MOTIVOS_BAJA;
  motivo: string = '';
  comment: string = '';
  materia_id !: number;
  materiaName !: string;
  titulos: any[] = [];
  titulo_id !: number;
  paginateOptions = MATERIAS_PAGINATION_OPTIONS_DEFAULT;
  isLoading: boolean = false;
  @ViewChild('modalDelete', { static: true }) modalDelete!: TemplateRef<any>;
  @ViewChild('modalTitulosVinculados', { static: true }) modalTitulosVinculados!: TemplateRef<any>;
  @ViewChild('emptyTemplate', { static: true }) emptyTemplate!: TemplateRef<any>;
  currentTemplate!: TemplateRef<any>;
  templateDelete: boolean = false;
  constructor(private cdr: ChangeDetectorRef) {
    super();
  }
  override ngOnInit(): void {
    this.isLoading = false;
    this.getNiveles();
    this.getModalidades();
    this.fetchMateriasByNivelModalidad(MATERIAS_PAGINATION_OPTIONS_DEFAULT, true);
    this.currentTemplate = this.emptyTemplate;
    this.cdr.detectChanges();
  }
  selectValueModalidad(value: number) {
    this.modalidadSelected = value;
    this.pageIndex = 0;
    this.skip = 0;
    this.paginationService.setPageIndex(this.entityKey, 0);
    this.fetchMateriasByNivelModalidad({ ...MATERIAS_PAGINATION_OPTIONS_DEFAULT, skip: 0 }, true);
  }
  getNiveles() {
    this.nivelService.getAllForSelect().subscribe((data) => {
      this.dataSelectNiveles = data
    });
  }
  getModalidades() {
    // Usar una copia para no modificar el objeto por defecto global
    const paginateOptions = { ...defaultPaginateSelects, mainFilterField: "nivel_id", mainValueToFilter: this.nivelSelected };
    this.modalidadService.getAllForSelect(paginateOptions).subscribe((data) => {
      this.dataSelectModalidades = data;
    });
  }
  fetchMateriasByNivelModalidad(data: PaginateOptions = MATERIAS_PAGINATION_OPTIONS_DEFAULT, ignoreCache: boolean = false) {
    data = { ...data };
    // Guarda el pageIndex en el servicio y actualiza la propiedad
    if (data.skip !== undefined && data.take !== undefined) {
      const page = Math.floor(data.skip / data.take);
      this.paginationService.setPageIndex(this.entityKey, page);
      this.pageIndex = page;
    }
    this.apiService.getMateriasByNivelModalidad(data, this.nivelSelected, this.modalidadSelected, ignoreCache).subscribe((data: any) => {
      this.dataFetch = { ...data };
      this.totalItems = this.dataFetch.total_items;
    });
  }
  selectValueNivel(value: number) {
    this.nivelSelected = value;
    this.pageIndex = 0;
    this.skip = 0;
    this.paginationService.setPageIndex(this.entityKey, 0);
    this.getModalidades();
    this.fetchMateriasByNivelModalidad({ ...MATERIAS_PAGINATION_OPTIONS_DEFAULT, skip: 0 }, true);
  }
  delete(materia_id: number) {
    if (this.titulo_id && this.materia_id) {
      this.materiasService.deleteFromTitulo(this.titulo_id, materia_id, this.motivo, this.comment).subscribe(() => {
      });
    }
  }
  getTemplateByName(name: string): TemplateRef<any> {
    switch (name) {
      case 'modalDelete':
        return this.modalDelete;
      case 'modalTitulosVinculados':
        return this.modalTitulosVinculados;
      default:
        return this.emptyTemplate;
    }
  }
  openModal(event: any) {
    // Limpio datos para evitar que se muestren datos anteriores mientras se carga la información nueva
    this.titulo_id = null!;
    this.materia_id = null!;
    this.motivo = '';
    this.comment = '';
    this.titulos = [];
    this.materiaName = '';
    if (event.action === 'eliminarMateria') {
      this.templateDelete = true;
    } else {
      this.templateDelete = false;
    }
    this.materiasService.getById(event.id).subscribe((materia: any) => {
      this.materiaName = materia.descripcion;
    });
    this.isLoading = true;
    this.materia_id = event.id;
    // Clonar el objeto de paginación antes de modificarlo
    const paginateDataMateria = { ...this.paginateOptions, mainFilterField: 'materia_id', mainValueToFilter: event.id };
    const titulosMethod = event.action === 'eliminarMateria'
      ? this.materiasService.getTitulosActivosByMateria.bind(this.materiasService)
      : this.materiasService.getTitulosByMateria.bind(this.materiasService);
    titulosMethod(paginateDataMateria, this.materia_id, this.nivelSelected , true).subscribe((data: any) => {
      this.isLoading = false;
      this.titulos = data.map((titulo: any) => ({
        value: titulo.id,
        label: titulo.descripcion,
        observacion: titulo.observacion,
        deleted_at: titulo.deleted_at
      }));
    });
  }
  mostrarEliminar() {
    this.currentTemplate = this.modalDelete;
  }

  mostrarListado() {
    this.currentTemplate = this.modalTitulosVinculados;
  }
}
